<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <h5 style="text-align: center"></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <h5 style="text-align: center">General</h5>
          <hr />
          <h6>GENERAL</h6>
          <hr />
          <b-form-group
            id="input-group-jobStartDateTime"
            label="Job start date time:"
            label-for="input-jobStartDateTime"
          >
            <b-form-input
              id="input-jobStartDateTime"
              v-model="form.jobStartDateTime"
              type="datetime-local"
              placeholder="Enter Job start date time"
              lazy
              :disabled="!editable"
              @change="jobStartDateTimeChanged"
              @blur="jobStartDateTimeChanged"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-endDateTime"
            label="End date time:"
            label-for="input-endDateTime"
          >
            <b-form-input
              id="input-endDateTime"
              v-model="form.endDateTime"
              type="datetime-local"
              placeholder="Enter End date time"
              lazy
              :disabled="!editable"
              @change="endDateTimeChanged"
              @blur="endDateTimeChanged"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-contractor"
            label="Contractor:"
            label-for="input-contractor"
          >
            <b-form-input
              id="input-contractor"
              v-model="form.contractor"
              type="text"
              placeholder="Enter Contractor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-jobType"
            label="Job type:"
            label-for="input-jobType"
          >
            <b-form-input
              id="input-jobType"
              v-model="form.jobType"
              type="text"
              placeholder="Enter Job type"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-engineer"
            label="Engineer:"
            label-for="input-engineer"
          >
            <b-form-input
              id="input-engineer"
              v-model="form.engineer"
              type="text"
              placeholder="Enter Engineer"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-loggedInterval"
            label="Logged interval:"
            label-for="input-loggedInterval"
          >
            <b-form-input
              id="input-loggedInterval"
              v-model="form.loggedInterval"
              type="number"
              step="0.001"
              placeholder="Enter Logged interval"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-reason"
            label="Reason:"
            label-for="input-reason"
          >
            <b-form-input
              id="input-reason"
              v-model="form.reason"
              type="text"
              placeholder="Enter Reason"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-totalLoggingTime"
            label="Total logging time:"
            label-for="input-totalLoggingTime"
          >
            <b-form-input
              id="input-totalLoggingTime"
              v-model="form.totalLoggingTime"
              type="number"
              step="0.001"
              placeholder="Enter Total logging time"
              :disabled="true"
              lazy
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 style="text-align: center">Hole Conditioning</h5>
          <hr />
          <b-form-group
            id="input-group-noOfSamplesTaken"
            label="No of samples taken:"
            label-for="input-noOfSamplesTaken"
          >
            <b-form-input
              id="input-noOfSamplesTaken"
              v-model="form.noOfSamplesTaken"
              type="number"
              step="0.001"
              placeholder="Enter No of samples taken"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noOfPressureAttempts"
            label="No of pressure attempts:"
            label-for="input-noOfPressureAttempts"
          >
            <b-form-input
              id="input-noOfPressureAttempts"
              v-model="form.noOfPressureAttempts"
              type="number"
              step="0.001"
              placeholder="Enter No of pressure attempts"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noOfPressureAttemptsObtained"
            label="No of pressure attempts obtained:"
            label-for="input-noOfPressureAttemptsObtained"
          >
            <b-form-input
              id="input-noOfPressureAttemptsObtained"
              v-model="form.noOfPressureAttemptsObtained"
              type="number"
              step="0.001"
              placeholder="Enter No of pressure attempts obtained"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-stopCirculation"
            label="Stop circulation :"
            label-for="input-stopCirculation"
          >
            <b-form-input
              id="input-stopCirculation"
              v-model="form.stopCirculation"
              type="datetime-local"
              placeholder="Enter Stop circulation "
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-timeBitSurface"
            label="Time bit  surface:"
            label-for="input-timeBitSurface"
          >
            <b-form-input
              id="input-timeBitSurface"
              v-model="form.timeBitSurface"
              type="datetime-local"
              placeholder="Enter Time bit  surface"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>SIDEWALL CORES</h6>
          <hr />
          <b-form-group
            id="input-group-noOfCoresShot"
            label="No of cores shot:"
            label-for="input-noOfCoresShot"
          >
            <b-form-input
              id="input-noOfCoresShot"
              v-model="form.noOfCoresShot"
              type="number"
              placeholder="Enter No of cores shot"
              :lazy="true"
              :disabled="!editable"
              @change="noOfCoresShotChanged"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noOfCoresRecovered"
            label="No of cores recovered:"
            label-for="input-noOfCoresRecovered"
          >
            <b-form-input
              id="input-noOfCoresRecovered"
              v-model="form.noOfCoresRecovered"
              type="number"
              placeholder="Enter No of cores recovered"
              :lazy="true"
              :disabled="!editable"
              @change="noOfCoresRecoveredChanged"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noOfCoresLost"
            label="No of cores lost:"
            label-for="input-noOfCoresLost"
          >
            <b-form-input
              id="input-noOfCoresLost"
              v-model="form.noOfCoresLost"
              type="number"
              placeholder="Enter No of cores lost"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-noOfCoresWNoRecovery"
            label="No of cores w no recovery:"
            label-for="input-noOfCoresWNoRecovery"
          >
            <b-form-input
              id="input-noOfCoresWNoRecovery"
              v-model="form.noOfCoresWNoRecovery"
              type="number"
              placeholder="Enter No of cores w no recovery"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>LOST TIME </h6>
          <hr />
          <b-form-group
            id="input-group-lostTimeForLateArrival"
            label="Lost time for late arrival:"
            label-for="input-lostTimeForLateArrival"
          >
            <b-form-input
              id="input-lostTimeForLateArrival"
              v-model="form.lostTimeForLateArrival"
              type="number"
              step="0.001"
              placeholder="Enter Lost time for late arrival"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lostTimeForComputerSoftware"
            label="Lost time for computer software:"
            label-for="input-lostTimeForComputerSoftware"
          >
            <b-form-input
              id="input-lostTimeForComputerSoftware"
              v-model="form.lostTimeForComputerSoftware"
              type="number"
              step="0.001"
              placeholder="Enter Lost time for computer software"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lostTimeWaitingOnTools"
            label="Lost time waiting on tools:"
            label-for="input-lostTimeWaitingOnTools"
          >
            <b-form-input
              id="input-lostTimeWaitingOnTools"
              v-model="form.lostTimeWaitingOnTools"
              type="number"
              step="0.001"
              placeholder="Enter Lost time waiting on tools"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h6>RESISTIVITY</h6>
          <hr />
          <b-form-group
            id="input-group-mudResistivity"
            label="Mud resistivity:"
            label-for="input-mudResistivity"
          >
            <b-form-input
              id="input-mudResistivity"
              v-model="form.mudResistivity"
              type="number"
              step="0.001"
              placeholder="Enter Mud resistivity"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-filtrateResistivity"
            label="Filtrate resistivity:"
            label-for="input-filtrateResistivity"
          >
            <b-form-input
              id="input-filtrateResistivity"
              v-model="form.filtrateResistivity"
              type="number"
              step="0.001"
              placeholder="Enter Filtrate resistivity"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-filterCakeResistivity"
            label="Filter cake resistivity:"
            label-for="input-filterCakeResistivity"
          >
            <b-form-input
              id="input-filterCakeResistivity"
              v-model="form.filterCakeResistivity"
              type="number"
              step="0.001"
              placeholder="Enter Filter cake resistivity"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h6>COMMENTS</h6>
          <hr />
          <b-form-group
            id="input-group-resistivityComments"
            label="Comments:"
            label-for="input-resistivityComments"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-resistivityComments"
              v-model="form.resistivityComments"
              type="text"
              rows="5"
              placeholder="Enter Resistivity Comments"
              :disabled="!editable"
            ></b-form-textarea>
          </b-form-group>

          <hr />
          <h5 style="text-align: center">Interval</h5>
          <hr />
          <LoggingInterval :submit-id="submitId" :editable-ops="editable" />

          <hr />
          <h5 style="text-align: center">Reference</h5>
          <hr />
          <h6>CURRENT LOGS</h6>
          <hr />
          <b-form-group
            id="input-group-linerTopMd"
            label="Liner top MD:"
            label-for="input-linerTopMd"
          >
            <b-form-input
              id="input-linerTopMd"
              v-model="form.linerTopMd"
              type="number"
              step="0.001"
              placeholder="Enter Liner top MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tubingMd"
            label="Tubing MD:"
            label-for="input-tubingMd"
          >
            <b-form-input
              id="input-tubingMd"
              v-model="form.tubingMd"
              type="number"
              step="0.001"
              placeholder="Enter Tubing MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fillMd"
            label="Fill MD:"
            label-for="input-fillMd"
          >
            <b-form-input
              id="input-fillMd"
              v-model="form.fillMd"
              type="number"
              step="0.001"
              placeholder="Enter Fill MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-plugbackMd"
            label="Plugback MD:"
            label-for="input-plugbackMd"
          >
            <b-form-input
              id="input-plugbackMd"
              v-model="form.plugbackMd"
              type="number"
              step="0.001"
              placeholder="Enter Plugback MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-totalDepth"
            label="Total Depth:"
            label-for="input-totalDepth"
          >
            <b-form-input
              id="input-totalDepth"
              v-model="form.totalDepth"
              type="number"
              step="0.001"
              placeholder="Enter Total Depth"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5 style="text-align: center">Repeat Formation Test</h5>
          <hr />
          <b-form-group
            id="input-group-sampleNo"
            label="Sample no:"
            label-for="input-sampleNo"
          >
            <b-form-input
              id="input-sampleNo"
              v-model="form.sampleNo"
              type="number"
              step="0.001"
              placeholder="Enter Sample no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-formation"
            label="Formation:"
            label-for="input-formation"
          >
            <b-form-input
              id="input-formation"
              v-model="form.formation"
              type="text"
              placeholder="Enter Formation"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-md"
            label="MD:"
            label-for="input-md"
          >
            <b-form-input
              id="input-md"
              v-model="form.md"
              type="number"
              step="0.001"
              placeholder="Enter MD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-tvd"
            label="TVD:"
            label-for="input-tvd"
          >
            <b-form-input
              id="input-tvd"
              v-model="form.tvd"
              type="number"
              step="0.001"
              placeholder="Enter TVD"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sampleType"
            label="Sample type:"
            label-for="input-sampleType"
          >
            <b-form-input
              id="input-sampleType"
              v-model="form.sampleType"
              type="text"
              placeholder="Enter Sample type"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sampleVolume"
            label="Sample volume:"
            label-for="input-sampleVolume"
          >
            <b-form-input
              id="input-sampleVolume"
              v-model="form.sampleVolume"
              type="number"
              step="0.001"
              placeholder="Enter Sample volume"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-sampleGravity"
            label="Sample gravity:"
            label-for="input-sampleGravity"
          >
            <b-form-input
              id="input-sampleGravity"
              v-model="form.sampleGravity"
              type="number"
              step="0.001"
              placeholder="Enter Sample gravity"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-mudWeight"
            label="Mud weight:"
            label-for="input-mudWeight"
          >
            <b-form-input
              id="input-mudWeight"
              v-model="form.mudWeight"
              type="number"
              step="0.001"
              placeholder="Enter Mud weight"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-formationPressure"
            label="Formation pressure:"
            label-for="input-formationPressure"
          >
            <b-form-input
              id="input-formationPressure"
              v-model="form.formationPressure"
              type="number"
              step="0.001"
              placeholder="Enter Formation pressure"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-hydrostaticPress"
            label="Hydrostatic press:"
            label-for="input-hydrostaticPress"
          >
            <b-form-input
              id="input-hydrostaticPress"
              v-model="form.hydrostaticPress"
              type="number"
              step="0.001"
              placeholder="Enter Hydrostatic press"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-setTime"
            label="Set time:"
            label-for="input-setTime"
          >
            <b-form-input
              id="input-setTime"
              v-model="form.setTime"
              type="number"
              step="0.001"
              placeholder="Enter Set time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-goodSeal"
            label="Good seal:"
            label-for="input-goodSeal"
          >
            <b-form-checkbox
              id="input-goodSeal"
              v-model="form.goodSeal"
              type="number"
              step="0.001"
              placeholder="Enter Good seal"
              :disabled="!editable"
              checked="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </b-form-group>
          <b-form-group
            id="input-group-temperature"
            label="Temperature:"
            label-for="input-temperature"
          >
            <b-form-input
              id="input-temperature"
              v-model="form.temperature"
              type="number"
              step="0.001"
              placeholder="Enter Temperature"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-repeatFormationTestComments"
            label="Repeat Formation Test Comments:"
            label-for="input-repeatFormationTestComments"
          >
            <b-form-input
              id="input-repeatFormationTestComments"
              v-model="form.repeatFormationTestComments"
              type="text"
              placeholder="Enter Repeat Formation Test Comments"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 style="text-align: center">Remarks</h5>
          <hr />
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="input-remarks"
            class="col-md-12"
          >
            <b-form-textarea
              id="input-remarks"
              v-model="form.remarks"
              type="text"
              placeholder="Enter Remarks"
              rows="5"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import LoggingInterval from '@components/form/drilling-activity/logging-interval'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import notify from "devextreme/ui/notify"

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormGenerator)

export default {
  components: { LoggingInterval },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      editableOps: this.editable,
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
    form: function (val) {},
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.getActivityLogging({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {},
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityLogging({ params: data }).then((resp) => {
          this.form.intId = resp.data.intId
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityLogging({ params: data }).then((resp) => {
          this.hasData = true
          this.form.intId = resp.data.intId
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    noOfCoresRecoveredChanged(val) {
      if (this.form.noOfCoresShot) {
        this.form.noOfCoresLost = this.form.noOfCoresShot - val
      }
    },
    noOfCoresShotChanged(val) {
      if (this.form.noOfCoresRecovered) {
        this.form.noOfCoresLost = val - this.form.noOfCoresRecovered
      }
    },
    jobStartDateTimeChanged(val) {
      if (this.form.endDateTime) {
        this.form.totalLoggingTime = (
          (new Date(this.form.endDateTime).getTime() / 1000 -
            new Date(val).getTime() / 1000) /
          3600
        ).toFixed(2)
      }
    },
    endDateTimeChanged(val) {
      if (this.form.jobStartDateTime) {
        this.form.totalLoggingTime = (
          (new Date(val).getTime() / 1000 -
            new Date(this.form.jobStartDateTime).getTime() / 1000) /
          3600
        ).toFixed(2)
      }
    },
  },
}
</script>